<div class="badge" [ngClass]="{ small: smallVariant }">
  <span class="badge-bg" inlineSVG="/icons/icon-badge.svg"> </span>
  <span class="content"><ng-content></ng-content></span>
</div>
